import { useState, useEffect, useCallback } from 'react';

/**
 * Difyチャットボットバブルボタンの実際の位置・サイズから
 * その上に配置するための bottom オフセットを動的に計算する
 * フォールバック: '76px'
 */
export function useChatbotOffset(): string {
  const [bottom, setBottom] = useState('76px');

  const recalculate = useCallback(() => {
    const chatbotBtn = document.getElementById('dify-chatbot-bubble-button');
    if (!chatbotBtn) return;

    const display = window.getComputedStyle(chatbotBtn).display;
    if (display === 'none') return;

    const computedStyle = window.getComputedStyle(chatbotBtn);
    const btnBottom = parseFloat(computedStyle.bottom) || 24;
    const rect = chatbotBtn.getBoundingClientRect();
    const btnHeight = rect.height || 48;
    const gap = 16;

    setBottom(`${btnBottom + btnHeight + gap}px`);
  }, []);

  useEffect(() => {
    recalculate();

    // Difyの埋め込みスクリプトは非同期でボタンを生成するため、初期ポーリング
    const pollInterval = setInterval(recalculate, 500);
    const stopPoll = setTimeout(() => clearInterval(pollInterval), 8000);

    // DOMの変更も監視
    const observer = new MutationObserver(recalculate);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true });

    // リサイズ時にも再計算
    window.addEventListener('resize', recalculate);

    return () => {
      clearInterval(pollInterval);
      clearTimeout(stopPoll);
      observer.disconnect();
      window.removeEventListener('resize', recalculate);
    };
  }, [recalculate]);

  return bottom;
}